export default function LogoTopMiddle() {
  return <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
    <ellipse cx="30.7" cy="10.0497" rx="4.7" ry="4.67662" fill="#333333"/>
    <path d="M15 22.6667L46.7647 22.6667" stroke="#CFCFCF" stroke-width="3.5" stroke-linecap="round"/>
    <path d="M15 30.6667L46.7647 30.6667" stroke="#CFCFCF" stroke-width="3.5" stroke-linecap="round"/>
    <path d="M15 38.6667L46.7647 38.6667" stroke="#CFCFCF" stroke-width="3.5" stroke-linecap="round"/>
    <path d="M15 46.6667L46.7647 46.6667" stroke="#CFCFCF" stroke-width="3.5" stroke-linecap="round"/>
  </svg>
}
